import {
	FacilityMaintenanceVendor,
	Location,
	Model
} from ".";

export default class FacilityMaintenanceContact extends Model {
	get singularNoun() {
		return "contact";
	}

	get mutations() {
		return {
			locations: Location,
			vendor: FacilityMaintenanceVendor
		};
	}

	get locationNames() {
		if ( this.locations ) {
			return this.locations.map( st => st.name )
			.sort()
			.join( ", " );
		}
	}

	resource() {
		return "facility-maintenance/contacts";
	}
}
